import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {BillingStats} from "app/models/billing.model";
import {FilterParams} from "app/models/filter_form.model";
import {ChartParams} from "app/views/chart/chart.component";
import {EventsService} from "app/lib/EventsService";

import * as qs from 'qs';
import {BaseComponent} from "app/views/base.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {PaidDetailsComponent} from "app/views/modal/paid_details/paid_details.component";
import {PromocodeInfoComponent} from "./details/promocode_info/promocode_info.component";
import {MoneyDetailsComponent} from "app/billing/billing/details/money_details/money_details.component";
import { getTimeAsIntervals } from "app/lib/lib";
import {HelperService} from "app/lib/helper.service";
import { BillingService2 } from "../billing.service";
import { ITotals } from "../../models/responce_result.model";


@Component({
	selector: 'billing',
	templateUrl: './billing.component.html'
})
export class BillingComponent extends BaseComponent {
	stats: BillingStats[];
	
	totalLoader: boolean = false;
	total2Loader: boolean = false;
	paginationLoader: boolean = false;
	statsLoader: boolean = false;
	
	trialChart = new ChartParams();
	paidChart = new ChartParams();
	
	total: ITotals;
	total2: ITotals;
	
	public dontLoad: any = {};
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo', 'datePublished'],
		dateType: 'datePaid'
	};

	hideZeroColumns: boolean = true;
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.filter.addFilters.push('promocode');
		
		this.paidChart.setOptions({
			title: 'График оплат',
			names: {
				'paidCount': this.translate.__A('common.paidCount'),
				'paidSiteCount': this.translate.__A('billing.billing.paidSiteCount'),
				'paidFirstErrorCount': this.translate.__A('billing.billing.paidFirstErrorCount'),
				'paidSecondErrorCount': this.translate.__A('billing.billing.paidSecondErrorCount'),
				'uberCount': this.translate.__A('billing.billing.uberCount'),
				'cashlessCount': this.translate.__A('billing.billing.cashlessCount'),
				'trialToPaid': this.translate.__A('billing.billing.trialToPaid'),
				'recurrentCount': this.translate.__A('billing.billing.recurrentCount'),
				'randomDoubleManulaPaid': this.translate.__A('billing.billing.randomDoubleManulaPaid'),
				'promocodeCount': this.translate.__A('common.Promocode'),
				'firstPaidCount': this.translate.__A('billing.billing.firstPaidCount'),
				'repeatPaidCount': this.translate.__A('billing.billing.repeatPaidCount'),
				'firstRecCount': this.translate.__A('billing.billing.firstRecurrentCount'),
				'secondRecurrentCount': this.translate.__A('billing.billing.secondRecurrentCount'),
				'userManualErrorCount': this.translate.__A('billing.billing.userManualErrorCount'),
				'userRecurrentErrorCount': this.translate.__A('billing.billing.userRecurrentErrorCount'),
				'firstRecurrentCount': this.translate.__A('billing.billing.firstRecurrentCount'),
			},
			colors: {
				'firstPaidCount': '#ff7f0e',
				'repeatPaidCount': '#2ca02c',
				'firstRecurrentCount': '#d62728',
				'secondRecurrentCount': '#9467bd',
				'paidSiteCount': '#8c564b',
				'recurrentCount': '#e377c2',
				'paidFirstErrorCount': '#8001FF',
				'paidSecondErrorCount': '#a3107c',
				'promocodeCount': '#bcbd22',
				'uberCount': '#17becf',
				'userRecurrentErrorCount': '#0000ff',
			},
			showLabels: [
				'firstPaidCount', 'repeatPaidCount', 'paidSiteCount', 'promocodeCount',
				'userManualErrorCount', 'userRecurrentErrorCount',
			],
			isChartFilter: true
		});
	}
	
	
	async getData() {
		await this.getTotal();
		await this.getTrialChart();
		await this.getPaidChart();
		await this.getTotal2();
		await this.getPagination();
	}
	
	
	// Получить данные для тотала (дополнительного)
	async getTotal() {
		if (this.dontLoad.total) return true;
		
		this.total = null;
		
		if (!this.filter.filterParams.isShowBillingAdd) return true;
		
		this.totalLoader = true;
		this.total = await this.service2.siteBilling.total(
			this.filter.filterParams
		).toPromise();
		this.totalLoader = false;
	}
	
	
	// Получить данные для графика по триалам
	async getTrialChart() {
		if (this.dontLoad.trialChart) {
			return true;
		}
		
		if (!this.filter.filterParams.isShowBillingPeriod) {
			return true;
		}
		
		this.trialChart.showLoader();
		const { charts } = await this.service2.siteBilling.chart(
			this.filter.filterParams,
			'trialchart'
		).toPromise();
		
		this.trialChart.data = charts;
		this.trialChart.hideLoader();
		
		this.trialChart.setOptions({
			...new ChartParams().options,
			names: {
				count: this.translate.__A('billing.billing.trialToPaid'),
			},
		});
	}
	
	
	// Получить данные для графика
	async getPaidChart(params?: FilterParams) {
		if (this.dontLoad.paidChart) {
			return true;
		}

		this.paidChart.showLoader();
		const { charts } = await this.service2.siteBilling.chart(
			this.filter.getCopyFilterParams(params),
			'paidchart'
		).toPromise();
		this.paidChart.data = charts;
		this.paidChart.hideLoader();
	}
	
	
	// Получить данные для тотала
	async getTotal2() {
		if (this.dontLoad.total2) return true;
		
		this.total2 = null;
		
		this.total2Loader = true;
		this.total2 = await this.service2.siteBilling.get<ITotals>(
			this.filter.filterParams,
			'total2'
		).toPromise();
		this.total2Loader = false;
	}
	
	
	// Получить данные для пагинации
	async getPagination() {
		const me = this;
		
		if (me.dontLoad.pagination) {
			await me.getStats();
			return true;
		}
		
		if (me.filter.filterParams.period == 'summary') {
			await me.getStats();
			return true;
		}

		me.paginationLoader = true;
		
		const pagination = await me.service2.siteBilling.pagination(
			this.filter.filterParams
		).toPromise();
		me.pagination.fill(pagination);
		
		if (pagination) {
			me.updateLinks(
				me.service2.siteBilling.getRealFullRoute()
			);
		}

		me.paginationLoader = false;
		
		await me.getStats();
	}
	
	
	// Получить данные для stats
	async getStats() {
		const me = this;
		
		me.statsLoader = true;
		
		const { stats } = await me.service2.siteBilling.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;
		
		for (let stat of me.stats) {
			let dates = getTimeAsIntervals({
				timestamp: stat.timestamp,
				period: me.filter.filterParams.period
			});
			
			if (dates.length === 2) {
				stat.currentPeriod = dates[0] + '-' + dates[1];
			} else {
				stat.currentPeriod = dates[0];
			}
			
			stat.day = new Date(stat.timestamp).getDay();
			
			if (stat.currentPeriod == '') {
				stat.currentPeriod = 'summary';
			}
		}
		
		
		me.statsLoader = false;
		me.dontLoad = {};
	}
	
	
	// Клик по пагинации
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];
		
		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
		
		this.dontLoad = {
			total: true,
			trialChart: true,
			paidChart: true,
			total2: true,
			chart: true,
			pagination: true
		};
	}
	
	
	downloadTrials() {
		window.location.href = this.service2.siteBilling.downloadFileRoute(
			this.filter.filterParams
		);
	}
	
	
	async showDetails(key: string, stat: any, count: number, paidType?: string, currency?: string) {
		let title = `${stat.currentPeriod} - ${key === 'moneyCount' ? count / 100 : count}`;
		
		if (key === 'siteCount') {
			const modalRef = this.modalService.open(
				PaidDetailsComponent,
				{
					title: title,
					divide: 10,
					currentPage: 1,
					totalCount: count,
					params: this.filter.filterParams,
					groupDate: stat.groupDate
				},
				{size: 'hg'}
			);
			
			const { stats } = await this.service2.siteBilling.detail(
				this.filter.getCopyFilterParams({
					dateTime: stat.groupDate,
					page: 1,
					divide: 10
				}),
			).toPromise();
			modalRef.componentInstance.details = stats;
		} else if (key === 'moneyCount') {
			if (paidType && currency) {
				title = `${stat.currentPeriod}: ${this.__a('billing.billing.' + paidType)} (${count / 100} ${this.helper.currencyLabels[currency]})`;
			} else if (paidType) {
				title = `${stat.currentPeriod}: ${this.__a('billing.billing.' + paidType)} (${count / 100} ${this.helper.currencyLabels['usd']})`;
			}
			
			const modalRef = this.modalService.open(
				MoneyDetailsComponent,
				{ title },
				{size: 'hg'}
			);
			
			const { stats } = await this.service2.siteBilling.stats(
				this.filter.getCopyFilterParams({ paidType, currency, dateTime: stat.groupDate, }),
				'money'
			).toPromise();
			modalRef.componentInstance.details = stats;
		} else if (key === 'promocodeCount') {
			const modalRef = this.modalService.open(
				PromocodeInfoComponent,
				{ title },
				{size: 'hg'}
			);
			
			const { stats } = await this.service2.siteBilling.stats(
				this.filter.getCopyFilterParams({ dateTime: stat.groupDate, }),
				'promocode'
			).toPromise();
			modalRef.componentInstance.details = stats;
		}
	}
	
	
	async updateData(filter, type) {
		if (type === 'paidChart') {
			await this.getPaidChart(filter);
		}
	}
}
